export default __webpack_public_path__ + "static/media/Amaury.1869d68d.jpg";